import { createStore } from 'satcheljs';
import { AttachmentFullViewState } from 'owa-attachment-full-view';
import { AttachmentViewState } from '../Schema/AttachmentViewState';

const initialStore: AttachmentViewState = {
    attachmentViewStates: new Map<string, AttachmentFullViewState>(),
};

export const getAttachmentViewStateStore = createStore<AttachmentViewState>(
    'FilesViewAttachmentViewStateStore',
    initialStore
);
